import { Endpoints } from '@/network';
import { baseForPdf } from '@/services/apiClients';

export interface INote {
  _id: string;
  bookId: string;
  chapterId: string;
  userId: string;
  excerpt: string;
  chapterNumber: number;
  content: string;
  pageNumber: number;
  coordinates?: {
    x: number;
    y: number;
    width?: number;
    height?: number;
  };
  type?: 'highlight' | 'comment' | 'bookmark';
  isPublic?: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export type INoteCreateBody = Omit<
  INote,
  '_id' | 'userId' | 'createdAt' | 'updatedAt'
>;

export interface IGroupedNotes {
  chapterId: string;
  chapterName: string;
  notes: INote[];
}

export const getNotesByBookId = async (
  bookId: string,
): Promise<IGroupedNotes[]> => {
  const response = await baseForPdf.get(Endpoints.pdfNotes, {
    params: { bookId },
  });
  return response?.data?.data;
};

export const getNoteById = async (noteId: string): Promise<INote> => {
  const response = await baseForPdf.get(`${Endpoints.pdfNotes}/${noteId}`);
  return response?.data?.data;
};

export const createNote = async (data: INoteCreateBody): Promise<INote> => {
  const response = await baseForPdf.post(Endpoints.pdfNotes, data);
  return response?.data?.data;
};

export const updateNote = async (
  noteId: string,
  data: Partial<INoteCreateBody>,
): Promise<INote> => {
  const response = await baseForPdf.put(
    `${Endpoints.pdfNotes}/${noteId}`,
    data,
  );
  return response?.data?.data;
};

export const deleteNote = async (noteId: string): Promise<void> => {
  await baseForPdf.delete(`${Endpoints.pdfNotes}/${noteId}`);
};
